export const CDN_URL = 'https://static.rechargecdn.com';
export const DISCOUNTED = 'DISCOUNTED';
export const ORIGINAL = 'ORIGINAL';
export const COMPARE_AT = 'COMPARE_AT';
export const SUBSCRIPTION = 'SUBSCRIPTION';
export const ONETIME = 'ONETIME';
export const SUBSCRIPTION_ONLY = 'subscription_only';
export const MONEY_STRING = '____MONEY____';
export const PRICE_SELECTORS = [
    '#ProductPrice',
    '#productPrice',
    '#ProductPrice-product-template',
    '#productPrice-product-template',
    '#ProductPrice-product',
    '.price',
    '.product-price',
    '.Price',
    '.product-single__price',
    '.product__price',
    '.price-field',
    '.price-item',
    '.ProductMeta__PriceList',
    '.actual-price',
    '.price-list',
    '.current-price',
    '.current_price',
    '.product__current-price',
    '.add-to-cart__price',
    '.ProductMeta__Price',
    '[data-product-price]',
    'span[itemprop="price"]',
    '.product-meta__price', // Kagami
    '.add-to-cart__price',
    '.price--main',
    '.js-add-btn-price'
];
export const COMPARE_TAGS = ['s', 'del', 'strike'];
export const COMPARE_STRINGS = ['compare', 'was', 'original', 'striped', 'old'];
export const STEP_LIMIT = 5;
export const VARIANT_OPTIONS = [
    '.single-option-selector',
    '.single-option-selector__radio',
    'input[data-product-option]',
    'input[name^="option-"]',
    'input[data-option-position]',
    'button[data-option-position].is-selected',
    'select[data-product-option]',
    '.product-single__swatch__input',
    'input[data-title]'
];
export const PRODUCT_FORMS = ['form[data-productid]'];
export const WIDGET_DEFAULTS = {
    onetime_message: 'One-time purchase',
    subscribe_message: 'Subscribe and save',
    widget_deliver_every: 'Deliver every',
    font_color: '#040404',
    active_color: '#000000',
    background_color: '#efefef',
    subscription_details_verbiage: 'Subscription details',
    popup_background_color: '#606060',
    popup_text_color: '#e7e7e7',
    popup_link_color: '#ffffff',
    how_it_works:
        '<strong>How subscriptions work</strong><br><br>Products are automatically delivered on your schedule. No obligation, modify or cancel your subscription anytime.',
    select_subscription_first: 'false',
    widget_icon: 'black',
    show_subscription_details: 'true',
    show_subscription_details_icon: 'true',
    show_learnmore: 'true',
    show_poweredby: 'true',
    learnmore_url:
        'http://rechargepayments.com/subscribe-with-recharge?utm_source=shopify%20store&shop_name={{ shop.name | url_param_escape }}&shop={{ shop.permanent_domain }}',
    learnmore_verbiage: 'Learn more...',
    poweredby_url:
        'http://rechargepayments.com/subscribe-with-recharge?utm_source=shopify%20store&shop={{ shop.permanent_domain }}',
    first_option: 'onetime',
    translations:
        '{"days":"Days","month":"Month","months":"Months","week":"Week","weeks":"Weeks"}'
};
